__turbopack_context__.v({
  "className": "anton_47696113-module__vuai9W__className",
});
